import { render, staticRenderFns } from "./GerenciarPlanos.vue?vue&type=template&id=539f907c&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarPlanos.vue?vue&type=style&index=0&id=539f907c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f907c",
  null
  
)

export default component.exports